import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './shared/guards/auth.guard';

import { LayoutComponent } from './components/layout/layout.component';
import { LoginComponent } from './components/user/login.component';

import { mceUploadRoutes, mceBrowseRoutes } from './routes/mce.routes';
import { userRoutes } from './routes/user.routes';
import { rootRoute } from './routes/root.routes';
import { noveltiesRoutes } from './routes/novelties.routes';
import { pagesRoutes } from './routes/pages.routes';
import { settingsRoutes } from './routes/settings.routes';
import { appearanceRoutes } from './routes/appearance.routes';
import { menuRoutes } from './routes/menu.routes';
import { newsletterRoutes } from './routes/newsletter.routes';
import { formsRoutes } from './routes/forms.routes';
import { filesRoutes } from './routes/files.routes';
import { homepageRoutes } from './routes/homepage.routes';
import { realEstateRoutes } from './routes/real-estate.routes';
import { appointmentRoutes } from './routes/appointment.routes';
import { bookingRoutes } from './routes/booking.routes';
import { contactRoutes } from './routes/contact.routes';
import { productsRoutes } from './routes/products.routes';
import { careerRoutes } from './routes/career.routes';
import { certsRoutes } from './routes/certs.routes';
import { footerRoutes } from './routes/footer.routes';

const appRoutes: Routes = [
  // login
  {
    path: 'login',
    component: LoginComponent
  },
  /* normal routes behind auth */
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      mceUploadRoutes,
      mceBrowseRoutes,
      {
        path: '',
        component: LayoutComponent,
        children: [
          rootRoute,
          userRoutes,
          noveltiesRoutes,
          pagesRoutes,
          settingsRoutes,
          appearanceRoutes,
          menuRoutes,
          newsletterRoutes,
          formsRoutes,
          filesRoutes,
          homepageRoutes,
          realEstateRoutes,
          appointmentRoutes,
          bookingRoutes,
          contactRoutes,
          productsRoutes,
          careerRoutes,
          certsRoutes,
          footerRoutes
        ],
        canActivate: [AuthGuard]
      }
    ]
  },
  // redirect to login if not authorized
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
